const conversionTable = {
    SECURITYNAME: 'LONG_NAME',
    FUNDMGRNAME: 'FUNDMGRNAME',
    PRICE: 'LAST',
    PRICECHANGEPCT: 'CHANGE_PCT',
    RET1WEEK: 'CHANGE_7DAYS_PCT',
    RET1M: 'CHANGE_MONTH_PCT',
    RET6M: 'CHANGE_6MONTHS_PCT',
    RETGAVG1YR: 'CHANGE_1YEAR_PCT',
    RETGAVG3YR: 'CHANGE_3YEARS_PCT',
    RETGAVG5YR: 'CHANGE_5YEARS_PCT',
    QUOTATIONCURRENCY: 'CURRENCY',
    TIME: 'TIME',
    ITEM: 'ITEM',
    SECTOR: 'SECTOR',
    INSTRUMENT_TYPE: 'INSTRUMENT_TYPE',
};

export function convertFundColumns(fund) {
    const newFund = { key: fund.key, values: {} };
    Object.keys(fund.values).forEach(key => {
        if (conversionTable[key]) {
            newFund.values[conversionTable[key]] = fund.values[key];
        }
    });

    // newFund.values.CHANGE = (fund.values.PRICE / 100) * fund.values.PRICECHANGEPCT;

    return newFund;
}



/** WEBPACK FOOTER **
 ** /src/shared/service/funds.js
 **/